export default __webpack_public_path__ + "static/agnieszka_alingua-b2d0e8f62abb0d14a2bb47d7ca7ee7a9.jpg";